import { createStyles, makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import React, { useRef } from "react";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      cursor: "pointer",
      width: 211.3,
      height: 234,
      border: "dashed 1px  #707070",
      display: "flex",
      justifyContent: "center",
      borderRadius: 7,
      marginBottom: 6,
    },
    content: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },
    img_empty: {
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      position: "absolute",
    },
    img_loaded: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      position: "relative",
    },
    img: {
      height: "100%",
      width: "100%",
    },
    label: {
      display: "block",
    },
    closeIcon: {
      cursor: "pointer",
      color: "#f44336",
      marginRight: "auto",
      position: "absolute",
      right: 5,
    },
  })
);

interface props {
  onChange: (data: any) => void;
}

export function ImageUpload({ onChange }: props) {
  const classes = useStyles();
  const [image, setImage] = React.useState(null);
  const dispatchAlert = useAlertDispatch();
  const ref = useRef(null);
  const { text } = useText();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files[0]) {
      const { type } = files[0];
      if (type.indexOf("image") !== 0) {
        return dispatchAlert({
          message: "the image is not deleted",
          severity: "warning",
        });
      }
      setImage(URL.createObjectURL(files[0]));
      // call onChanges method given by the parent component
      onChange(files[0]);
    }
  };

  return (
    <>
      {image ? (
        <div className={classes.img_loaded}>
          <img src={image} className={classes.img} alt="img" />
          <CloseIcon
            className={classes.closeIcon}
            onClick={() => {
              onChange(null);
              setImage(null);
            }}
          />
        </div>
      ) : (
        <div onClick={(event) => ref.current.click()} className={classes.root}>
          <div className={classes.content}>
            <input
              id="img"
              ref={ref}
              name="uploaded_img"
              type="file"
              accept="image/png, image/jpeg, image/jpg"
              hidden
              onChange={handleChange}
            />
            <AddIcon fontSize="large" />
            <label className={classes.label}>{text.user.add_photo}</label>
          </div>
        </div>
      )}
    </>
  );
}
